import React from 'react';
import { Card, Descriptions } from 'antd';
import PropTypes from 'prop-types';
import { DateDisplay, SanitizedHTML } from 'components/layout';

const FundingDetail = ({ data }) => {
  return (
    <Card title="Funding Detail" style={{ margin: '24px 0' }}>
      <Descriptions column={1}>
        <Descriptions.Item
          label="Funding"
          className="ant-descriptions-item-bold"
        >
          {data?.title}
        </Descriptions.Item>
        <Descriptions.Item label="Application Period">
          <DateDisplay date={data?.startDate} />
          {` - `}
          <DateDisplay date={data?.endDate} />
        </Descriptions.Item>
        <Descriptions.Item label="Deadline for Using Allocated Funds">
          <DateDisplay date={data?.deadlineOfUsingUpFunding} />
        </Descriptions.Item>
        <Descriptions.Item>
          <SanitizedHTML dirty={data.description} />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

FundingDetail.propTypes = {
  data: PropTypes.object,
};

export default FundingDetail;
